import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field, reset } from "redux-form";
import { FormField } from "../../../sharedComponents/formField";

import { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { getExerciseFilters } from "../../../store/actions";

const AdvancedFilterPanel = ({ handleSubmit, resetForm, getExerciseFilters, exerciseFilters, toggle }) => {
	useEffect(() => {
		getExerciseFilters();
	}, [getExerciseFilters]);

	const resetFilter = () => {
		resetForm("ExercisesAdvancedFilter");
		setTimeout(()=>{
			handleSubmit();
		},100);
		toggle();
	};

	return (
		<form className="advanced-filter-form d-flex flex-fill flex-column" onSubmit={handleSubmit}>
			<PanelBody>
				<div className="row">
					{exerciseFilters &&
						exerciseFilters.length > 0 &&
						exerciseFilters.map(({ group, id, name, label }, index) => {
							return (
								<Field
									key={index}
									label={label}
									name={name}
									type="select"
									formGroupClass="col-6"
									options={group}
									component={FormField}
								/>
							);
						})}
				</div>
			</PanelBody>
			<PanelFooter className="pt-0 pb-0">
				<div className="text-right pt-3 pb-3">
					<button className="btn btn-default" type="button" onClick={resetFilter}>
						Reset
					</button>
					<button className="btn btn-primary-dark text-uppercase" type="submit">
						Fiter now
					</button>
				</div>
			</PanelFooter>
		</form>
	);
};

const mapStateToProps = (state) => {
	const { Exercises } = state;
	return {
		exerciseFilters: get(Exercises, "exerciseFilters", [])
	};
};

const mapDispatchToProps = {
	resetForm: reset,
	getExerciseFilters
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "ExercisesAdvancedFilter"
	})(AdvancedFilterPanel)
);
